var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnailInsWasserFaelltEinSteinLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 576,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 576,
    fill: "#c5a590"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#210000",
    fillOpacity: 0.501961,
    points: "77,159 210,139 112,17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffff5",
    fillOpacity: 0.501961,
    points: "142,-16 -16,2 25,159"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "145,-12 271,1 224,70"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#36221d",
    fillOpacity: 0.501961,
    points: "181,30 193,151 115,143"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b36b44",
    fillOpacity: 0.501961,
    points: "87,130 91,54 244,94"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff0d7",
    fillOpacity: 0.501961,
    points: "76,-16 -16,5 95,159"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#120000",
    fillOpacity: 0.501961,
    points: "113,80 91,62 148,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "253,64 149,-1 271,-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "115,159 99,125 213,122"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#675035",
    fillOpacity: 0.501961,
    points: "254,64 200,65 208,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2bb9f",
    fillOpacity: 0.501961,
    points: "128,72 159,64 194,121"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1a1505",
    fillOpacity: 0.501961,
    points: "165,114 192,52 167,43"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffe9aa",
    fillOpacity: 0.501961,
    points: "195,145 254,68 270,140"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ad7752",
    fillOpacity: 0.501961,
    points: "57,111 -16,113 32,148"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "183,93 202,75 186,63"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "105,50 140,45 145,68"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e6865a",
    fillOpacity: 0.501961,
    points: "100,-9 169,92 150,-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3c0b06",
    fillOpacity: 0.501961,
    points: "94,119 86,84 102,47"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff5ff",
    fillOpacity: 0.501961,
    points: "-16,83 9,117 9,-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "208,123 207,106 180,109"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#11121b",
    fillOpacity: 0.501961,
    points: "200,116 96,134 198,159"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f08343",
    fillOpacity: 0.501961,
    points: "88,59 110,123 139,116"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "158,-16 210,60 271,-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#534848",
    fillOpacity: 0.501961,
    points: "139,91 212,85 212,107"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc984",
    fillOpacity: 0.501961,
    points: "271,65 225,65 228,24"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffdb",
    fillOpacity: 0.501961,
    points: "216,120 213,102 268,117"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffd9c5",
    fillOpacity: 0.501961,
    points: "102,132 -16,82 36,21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffe5c8",
    fillOpacity: 0.501961,
    points: "-3,-16 73,90 126,5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc99f",
    fillOpacity: 0.501961,
    points: "141,82 118,58 179,88"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#584d00",
    fillOpacity: 0.501961,
    points: "188,57 200,68 199,45"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#822a00",
    fillOpacity: 0.501961,
    points: "180,19 176,36 165,32"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#79452b",
    fillOpacity: 0.501961,
    points: "125,22 149,4 123,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f9caa5",
    fillOpacity: 0.501961,
    points: "147,5 130,22 193,36"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e8b995",
    fillOpacity: 0.501961,
    points: "95,119 92,149 -16,130"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#262325",
    fillOpacity: 0.501961,
    points: "122,78 93,56 129,21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c2261c",
    fillOpacity: 0.501961,
    points: "173,21 159,19 165,7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06040f",
    fillOpacity: 0.501961,
    points: "159,65 182,85 183,63"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7a176",
    fillOpacity: 0.501961,
    points: "164,111 148,112 166,90"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "203,117 179,113 198,106"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffe1",
    fillOpacity: 0.501961,
    points: "186,64 210,65 185,90"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#23120d",
    fillOpacity: 0.501961,
    points: "87,97 104,140 139,152"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffe0a1",
    fillOpacity: 0.501961,
    points: "253,118 271,53 214,110"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#110910",
    fillOpacity: 0.501961,
    points: "213,108 204,109 212,121"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b28b83",
    fillOpacity: 0.501961,
    points: "182,85 153,86 206,104"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff5d5",
    fillOpacity: 0.501961,
    points: "182,22 194,52 177,35"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dc8a75",
    fillOpacity: 0.501961,
    points: "124,31 164,79 155,22"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d5997f",
    fillOpacity: 0.501961,
    points: "271,121 203,145 203,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc169",
    fillOpacity: 0.501961,
    points: "88,19 128,7 118,-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffebd5",
    fillOpacity: 0.501961,
    points: "92,-2 37,-16 85,105"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "159,21 153,-16 168,-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#69462f",
    fillOpacity: 0.501961,
    points: "230,94 208,95 258,64"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffecbf",
    fillOpacity: 0.501961,
    points: "210,60 209,25 271,27"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#747e2b",
    fillOpacity: 0.501961,
    points: "207,74 173,46 194,52"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c62332",
    fillOpacity: 0.501961,
    points: "188,27 190,39 183,39"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#40414c",
    fillOpacity: 0.501961,
    points: "138,127 177,106 188,127"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff9cb",
    fillOpacity: 0.501961,
    points: "159,39 155,56 169,46"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#89522d",
    fillOpacity: 0.501961,
    points: "180,38 164,36 178,18"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "144,-2 265,32 271,-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#01020a",
    fillOpacity: 0.501961,
    points: "117,55 143,67 129,39"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#241b1c",
    fillOpacity: 0.501961,
    points: "210,87 182,87 206,94"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffee",
    fillOpacity: 0.501961,
    points: "186,33 222,64 223,31"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#08060b",
    fillOpacity: 0.501961,
    points: "107,134 105,159 150,112"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#09080a",
    fillOpacity: 0.501961,
    points: "204,127 187,159 181,134"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "86,120 72,119 63,98"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a1301c",
    fillOpacity: 0.501961,
    points: "175,37 161,66 183,45"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#832a08",
    fillOpacity: 0.501961,
    points: "153,33 143,38 154,43"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b78849",
    fillOpacity: 0.501961,
    points: "89,115 89,128 79,108"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e5ac85",
    fillOpacity: 0.501961,
    points: "101,14 89,12 89,58"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffefc4",
    fillOpacity: 0.501961,
    points: "118,25 118,-16 92,48"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#02020d",
    fillOpacity: 0.501961,
    points: "167,95 183,98 165,101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffbc82",
    fillOpacity: 0.501961,
    points: "222,46 269,44 240,65"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#432114",
    fillOpacity: 0.501961,
    points: "159,92 145,86 134,104"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b85d2c",
    fillOpacity: 0.501961,
    points: "140,79 144,97 90,74"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#612c1f",
    fillOpacity: 0.501961,
    points: "101,115 96,64 88,105"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#544134",
    fillOpacity: 0.501961,
    points: "110,52 127,66 130,98"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bb987f",
    fillOpacity: 0.501961,
    points: "12,151 -5,113 66,111"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9a0000",
    fillOpacity: 0.501961,
    points: "193,47 194,43 204,50"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7ffda",
    fillOpacity: 0.501961,
    points: "159,28 158,22 176,19"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffe9d3",
    fillOpacity: 0.501961,
    points: "213,159 173,146 268,135"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffff7",
    fillOpacity: 0.501961,
    points: "183,111 205,120 203,104"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffb286",
    fillOpacity: 0.501961,
    points: "141,79 169,80 113,57"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ab8064",
    fillOpacity: 0.501961,
    points: "252,64 213,107 208,66"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#18191c",
    fillOpacity: 0.501961,
    points: "99,48 127,77 94,66"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7f433f",
    fillOpacity: 0.501961,
    points: "140,47 156,65 147,69"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffffa",
    fillOpacity: 0.501961,
    points: "218,121 225,103 213,106"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dbb294",
    fillOpacity: 0.501961,
    points: "63,110 7,144 102,145"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d17741",
    fillOpacity: 0.501961,
    points: "148,111 124,124 99,104"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#140f17",
    fillOpacity: 0.501961,
    points: "169,85 165,62 182,84"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fee6c6",
    fillOpacity: 0.501961,
    points: "217,26 269,27 197,57"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eead97",
    fillOpacity: 0.501961,
    points: "125,32 134,43 163,14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "82,19 88,-16 124,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0bd8c",
    fillOpacity: 0.501961,
    points: "104,123 79,119 67,159"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7b341a",
    fillOpacity: 0.501961,
    points: "134,27 130,19 110,29"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7edfd",
    fillOpacity: 0.501961,
    points: "4,-16 -16,66 7,96"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "195,78 201,72 190,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffe1c3",
    fillOpacity: 0.501961,
    points: "117,11 105,44 84,57"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d1783f",
    fillOpacity: 0.501961,
    points: "106,120 98,94 127,75"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#635148",
    fillOpacity: 0.501961,
    points: "200,77 185,95 198,95"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#db9776",
    fillOpacity: 0.501961,
    points: "137,89 147,99 139,81"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fad3c1",
    fillOpacity: 0.501961,
    points: "-2,113 48,-16 53,110"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailInsWasserFaelltEinSteinLow);
export default __webpack_public_path__ + "static/media/thumbnail_ins_wasser_faellt_ein_stein_low.919bbea80f54d9995cd3d9e352e02fe0.svg";
export { ForwardRef as ReactComponent };